import type { IProduct } from '../models/product';
import type { IBadge } from '../models/badge';

/**
 * Функция преобразует бейджи продукта.
 * @param {IProduct} product - Выбранный продукт.
 * @return {IBadge[]} бейджи продукта.
 */
export function productToBadges(product: IProduct): IBadge[] {
  return (product.badges || []).map(({ id, text, backgroundColor, textColor }) => ({
    id,
    label: text,
    backgroundColor: backgroundColor as `#${string}`,
    color: textColor as `#${string}`,
  }));
}
